import { useGoogleLogin } from "@react-oauth/google"
import { useNavigate } from "react-router-dom"
import { useState } from "react"
import axios from "axios"
import "../styles/auth.css"

const API = process.env.REACT_APP_API_URL || "http://localhost:8000"

export default function Register() {
    const nav = useNavigate()
    const [error, setError] = useState("")
    const [success, setSuccess] = useState("")
    const [loading, setLoading] = useState(false)

    const googleRegister = useGoogleLogin({
        onSuccess: async (tokenResponse) => {
            setLoading(true); setError("")
            try {
                const res = await axios.post(`${API}/oauth/google`, {
                    token: tokenResponse.access_token,
                })
                localStorage.setItem("token", res.data.token)
                nav("/onboarding")
            } catch (err) {
                setError("Google registration failed. Please try email below.")
            } finally {
                setLoading(false)
            }
        },
        onError: () => setError("Google sign-up was cancelled or failed."),
    })

    const handleEmailRegister = async (e) => {
        e.preventDefault()
        setError(""); setSuccess(""); setLoading(true)
        const email    = e.target.email.value.trim().toLowerCase()
        const password = e.target.password.value

        try {
            const res = await axios.post(`${API}/register`, { email, password })

            // Backend returns 200 with status:created on success
            if (res.data.status === "created") {
                setSuccess(res.data.message || "Account created! Check your email to verify.")
                e.target.reset()
                return
            }
            setError("Unexpected response. Please try again.")
        } catch (err) {
            // Backend returns 400 with detail message on validation failures
            const detail = err.response?.data?.detail
            if (detail) {
                setError(detail)
            } else {
                setError("Registration failed. Please try again.")
            }
        } finally {
            setLoading(false)
        }
    }

    return (
        <div className="auth-page">
            <div className="auth-card">

                <div className="auth-logo">ArbSignal</div>
                <h2 className="auth-title">Start your free trial</h2>
                <p className="auth-sub">30 days free — no credit card required</p>

                <div className="auth-buttons">
                    <button
                        className="oauth-btn google-btn"
                        onClick={() => googleRegister()}
                        disabled={loading}
                    >
                        <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
                            <path d="M17.64 9.2c0-.637-.057-1.251-.164-1.84H9v3.481h4.844c-.209 1.125-.843 2.078-1.796 2.717v2.258h2.908c1.702-1.567 2.684-3.875 2.684-6.615z" fill="#4285F4"/>
                            <path d="M9 18c2.43 0 4.467-.806 5.956-2.18l-2.908-2.259c-.806.54-1.837.86-3.048.86-2.344 0-4.328-1.584-5.036-3.711H.957v2.332A8.997 8.997 0 009 18z" fill="#34A853"/>
                            <path d="M3.964 10.71A5.41 5.41 0 013.682 9c0-.593.102-1.17.282-1.71V4.958H.957A8.996 8.996 0 000 9c0 1.452.348 2.827.957 4.042l3.007-2.332z" fill="#FBBC05"/>
                            <path d="M9 3.58c1.321 0 2.508.454 3.44 1.345l2.582-2.58C13.463.891 11.426 0 9 0A8.997 8.997 0 00.957 4.958L3.964 7.29C4.672 5.163 6.656 3.58 9 3.58z" fill="#EA4335"/>
                        </svg>
                        Continue with Google
                    </button>
                </div>

                <div className="auth-divider"><span>or</span></div>

                <form className="auth-form" onSubmit={handleEmailRegister}>
                    <input
                        className="auth-input"
                        type="email"
                        name="email"
                        placeholder="Email address"
                        required
                        autoComplete="email"
                    />
                    <input
                        className="auth-input"
                        type="password"
                        name="password"
                        placeholder="Password (min 8 characters, letters + numbers)"
                        minLength={8}
                        required
                        autoComplete="new-password"
                    />
                    {error && (
                        <p style={{ color: "#f87171", fontSize: 13, margin: 0, padding: "10px", background: "rgba(248,113,113,0.1)", borderRadius: 6 }}>
                            {error}
                        </p>
                    )}
                    {success && (
                        <p style={{ color: "#00ffc6", fontSize: 13, margin: 0, padding: "10px", background: "rgba(0,255,198,0.1)", borderRadius: 6 }}>
                            {success}
                        </p>
                    )}
                    <button type="submit" className="auth-submit" disabled={loading}>
                        {loading ? "Creating account..." : "Create account"}
                    </button>
                </form>

                <p className="auth-footer">
                    Already have an account?{" "}
                    <span className="auth-link" onClick={() => nav("/login")}>
                        Sign in
                    </span>
                </p>

            </div>
        </div>
    )
}
